// export const environment = {
//   production: true,
//   baseUrl: 'https://devmgt-entregis.set.or.th/api',
//   redirectUrl: 'https://devmgt-entregis.set.or.th/login',
//   tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
//   clientId: '405c9650-3733-416f-8699-af0bdae4edcd',
//   publicUrl: 'https://dev-entregis.set.or.th',
//   adminUrl: 'https://devmgt-entregis.set.or.th',
//   webExClientId: 'C86ab38b90f84a1d8aaf96d2db5e1f649e8cf77c2edbb23f478a979bf7f3b1d96',
// };
export const environment = {
  production: true,
  baseUrl: 'https://dev-mgt-corporate-access.setstage.or.th/api',
  redirectUrl: 'https://dev-mgt-corporate-access.setstage.or.th/login',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: '405c9650-3733-416f-8699-af0bdae4edcd',
  publicUrl: 'https://dev-corporate-access.setstage.or.th',
  adminUrl: 'https://dev-mgt-corporate-access.setstage.or.th',
  webExClientId: 'C86ab38b90f84a1d8aaf96d2db5e1f649e8cf77c2edbb23f478a979bf7f3b1d96',
};